import { assert } from '@deqo/foundation';
import { injectable } from 'inversify';
import { Connector } from '../../Container';
import { AssistantToolSupport } from './AssistantToolSupport';

@injectable()
export class AssistantToolRegistry {

    private register = new Map<string, AssistantToolSupport>();

    public add(tool: AssistantToolSupport) {
        assert(!this.register.has(tool.toolName), `Assitant Tool already registered: ${tool.toolName}`);
        this.register.set(tool.toolName, tool);
    }

    public get(toolName: string): AssistantToolSupport | undefined {
        return this.register.get(toolName);
    }
}

export const inAssistantTools = (...tools: AssistantToolSupport[]): Connector =>
    r => void (tools.forEach(x => r.call(AssistantToolRegistry).add(x)));
